import React from 'react';
import MyAccountView from './MyAccountView';

const MyAccountViewController = () => {
    return <MyAccountView />
};

export default MyAccountViewController;